
<ion-input class="form-input" type="text" #googlePlaces placeholder="Enter new address"
  (keyup)="addressUpdates()" [(ngModel)]="formattedAddress">
</ion-input>
<div class="save-btn">
  <span (click)="saveNewAddress()">Save</span>
</div>
